import img from './img';
import audio from './audio';
import dataConfig from './gameData.config.js';

var config = {
  author: 'MP',
  engine: 'createJS',
  gameConfig: dataConfig,
  title: [
    {
      text: 'Znajdź 7 szczegółów, którymi różnią się obrazki. Klikaj w znalezione szczegóły na obrazku w niebieskiej ramce.',
      audio: 'games/page010_game1/audio/z10c1.mp3',
    },
  ],
  checkGameSound: {
    positive: 'games/page010_game1/audio/z10c1-brawo.mp3',
    // negative: 'games/page001_game1/audio/z1c1-brawo.mp3',
  },
  checkGameText: {
    positive: 'Ćwiczenie zostało wykonane. Brawo! ',
    negative: '',
  },
  assets: {
    img: img || [],
    audio: audio || [],
    extendetJS: [],
    extendetStyle: [],
  },
};

export default config;
